import "core-js/modules/es.function.name.js";
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["id", "value", "name", "checked"];
var _hoisted_2 = ["for"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    "class": _normalizeClass([_ctx.$attrs['class'], "tw-inline-block tw-mr-4 tw-mb-4"]),
    onClick: _cache[1] || (_cache[1] = _withModifiers(
    //@ts-ignore
    function () {
      return _ctx.handleClick && _ctx.handleClick.apply(_ctx, arguments);
    }, ["stop"]))
  }, [_createElementVNode("input", {
    id: _ctx.$attrs.id,
    ref: "checkbox",
    type: "radio",
    "class": "tw-hidden",
    value: _ctx.label,
    name: _ctx.$attrs.name,
    checked: _ctx.isChecked,
    onChange: _cache[0] || (_cache[0] = _withModifiers(
    //@ts-ignore
    function () {
      return _ctx.handleOnInput && _ctx.handleOnInput.apply(_ctx, arguments);
    }, ["stop"]))
  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1), _createElementVNode("label", {
    "class": _normalizeClass([_ctx.$attrs['label-classes'], "tw-flex tw-items-center tw-cursor-pointer"]),
    "for": _ctx.$attrs.id
  }, [_createElementVNode("span", {
    "class": _normalizeClass(["tw-w-4 tw-h-4 tw-inline-block tw-mr-2 tw-rounded-full tw-border tw-border-solid tw-border-w-secondary tw-flex-no-shrink tw-transition-colors tw-duration-200 tw-transform", {
      'tw-bg-w-primary tw-border-w-primary tw-shadow-[0_0_0_2px_white_inset]': _ctx.isChecked
    }])
  }, null, 2 /* CLASS */), _createTextVNode(" " + _toDisplayString(_ctx.label), 1 /* TEXT */)], 10 /* CLASS, PROPS */, _hoisted_2)], 2 /* CLASS */);
}